export enum PlayButtonLock {
  Unset = null,
  Live = 'live',
  Simulation = 'Simulation',
}
